import moment from "moment-timezone";
import { useAuth } from "../../../hooks/useAuth";

const useTimeZone = () => {
  const { selectedBusinessDetail } = useAuth();

  const businessTimeToUTC = (date) => {
    const businessTime = moment.tz(
      date,
      selectedBusinessDetail.business.timezone || "America/Los_Angeles"
    );
    const utcTime = businessTime.utc().format("YYYY-MM-DD HH:mm:ss");
    return utcTime;
  };

  const tzConverter = (dateParam, formatParam, sourceFormat) =>
    moment
      .utc(dateParam, sourceFormat || "YYYY-MM-DD HH:mm:ss")
      .tz(selectedBusinessDetail?.business?.timezone || "America/Los_Angeles")
      .format(formatParam);

  return { tzConverter, businessTimeToUTC };
};

export default useTimeZone;
